module.exports = __webpack_public_path__ + "img/certified.813b1bb.svg";